import React, { useEffect, useRef } from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as types from "../redux/actions/CMSData";
import { getActiveLang, withLang } from '../utils/language';

function PrivacyPolicy() {
  const isMounted = useRef(true);
  const dispatch = useDispatch();
  let CMSData = useSelector((state) => state.cmsdatadetail.cmsdatadetail);
  const PrivacyData = CMSData?.privacy_policy || {};
  const selectedLanguage = getActiveLang();

  useEffect(() => {
    if (isMounted.current) {
      if (!CMSData || CMSData.length === 0) {
        dispatch({ type: types.FETCH_CMSDATA_REQUEST });
      }
      isMounted.current = false;
    }
  }, []);

  const getContent = () => {
    if (selectedLanguage === 'ori') {
      return {
        otherDetails: PrivacyData?.other_details_ori,
      };
    } else {
      return {
        otherDetails: PrivacyData?.other_details_en,
      };
    }
  };

  return (
    <>
      <div className='innerPages'>
        <Container>
          <Row>
            <Col sm={12}>
              <h2>
                {selectedLanguage === 'ori' ? "ଗୋପନୀୟତା " : "Privacy "}
                <span>
                  {selectedLanguage === 'ori' ? "ନୀତି" : "Policy"}
                </span>
              </h2>
              <ul>
                <li><Link to={withLang("/")}>{selectedLanguage === 'ori' ? "ହୋମ୍" : "Home"}</Link></li>
                <li>/</li>
                <li><strong>
                  {selectedLanguage === 'ori' ? "ଗୋପନୀୟତା ନୀତି" : "Privacy Policy"}
                </strong></li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>

      <div className='aboutSection'>
        <Container>
          <Row className='d-flex align-items-center'>

            <Col sm={12}>
              <p className='text-justify ck-editor-text' dangerouslySetInnerHTML={{ __html: getContent().otherDetails }}></p>
            </Col>
          </Row>
        </Container>
      </div>
    </>)
}

export default PrivacyPolicy